import { Entidad } from './Entidad';
import { NodoFormulario_lite } from './NodoFormulario_lite';

export class BalizaFormulario_lite {
	Id: string;
	IdHardware: string;
	DescInstalacion: string;
	FechaInstalacion: Date;
	NivelBateria: Number;
	TimestampLecturaBateria: string;
	PasswordBeacons: string;
	potenciaTx: Number;
	FechaAlta: Date;
	FechaBaja: Date;
	FechaLecturaBateria: Date;
	X: Number;
	Y: Number;
	Latitud: Number;
	Longitud: Number;
	IconoRepresentacion: string;
	TipologiaNombre: string;

	// Objeto de Breeze
	ENTIDAD: any;

	constructor(){}

	fromENTIDAD(ENTIDAD: any): BalizaFormulario_lite{

		this.ENTIDAD = ENTIDAD;
		this.Id = ENTIDAD.Id;
		this.IdHardware = ENTIDAD.IdHardware;
		this.DescInstalacion = ENTIDAD.DescInstalacion;
		this.FechaInstalacion = ENTIDAD.FechaInstalacion;
		this.NivelBateria = ENTIDAD.NivelBateria;
		this.TimestampLecturaBateria = ENTIDAD.TimestampLecturaBateria;
		this.FechaLecturaBateria = ENTIDAD.FechaLecturaBateria;
		this.PasswordBeacons = ENTIDAD.PasswordBeacons;
		this.potenciaTx = ENTIDAD.potenciaTx;
		this.FechaAlta = ENTIDAD.FechaAlta;
		this.FechaBaja = ENTIDAD.FechaBaja;
		this.X = ENTIDAD.X;
		this.Y = ENTIDAD.Y;
		this.Latitud = ENTIDAD.Latitud;
		this.Longitud = ENTIDAD.Longitud;
		this.IconoRepresentacion = 'assets/itsoft/IconosSVG/SVG/' + 'nodo-baliza.svg';
		return this;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/BalizaFormulario_lite.ts